var app = angular.module('leonardo');

var AuthDataService = function ($q, $rootScope, $filter, SectorRestService, CategoryRestService,
                                SubCategoryRestService, AccountUserService, AccountService,
                                AccountUserRoleService, WhiteLabelService, AuthService, FilterService,
                                ConfigThemeService, ClientInstanceService, AnalyticsService, CacheService,
                                StatsigService, StatsigRestService, ZendeskService) {
  var service = {
    authData: {},
    accountUserRoleService: AccountUserRoleService
  };

  service.getCurrentAccountUser = function (list) {
    var account_user = null;
    angular.forEach(list, function (element) {
      if (!element.managed_by) {
        account_user = element;
      }
    });
    return account_user;
  };

  service.getAccountUser = function (account) {
    var accountId = account && account.id ? account.id : account;
    var result = service.getCurrentAccountUser(service.authData.accountUsers);
    angular.forEach(service.authData.accountUsers, function (account_user) {
      var UserAccountId = account_user.account && account_user.account.id ? account_user.account.id : account_user.account;
      if (UserAccountId == accountId) {
        result = account_user;
      }
    });
    return result;
  };

  service.getRolesValid = function (account, edit, noCancel) {
    var defer = $q.defer();
    var userRoles = [];
    var currentAccountUser = account ? service.getAccountUser(account) : AccountUserService.currentAccountUser;
    var accountUserRoles = [];
    if (currentAccountUser.role) {
      accountUserRoles = currentAccountUser.role.visible_roles;
      if (edit) {
        accountUserRoles = currentAccountUser.role.editable_roles;
      }
    }
    if (accountUserRoles.length > 0) {
      var ids = [];
      angular.forEach(accountUserRoles, function (role) {
        ids.push(role.id);
      });
      userRoles = AccountUserRoleService.getlist({ disable_pagination: true, account:account}, noCancel);
    }
    else if (account) {
      userRoles = AccountUserRoleService.getlist({disable_pagination:true, account:account}, noCancel);
    }
    else if (AccountUserRoleService.getCollection().length > 0) {
      userRoles = AccountUserRoleService.getCollection();
    }
    else {
      userRoles = AccountUserRoleService.getAll({essential:true, system:(service.isAdmin() || service.isWhiteLabelAdmin())}, true, noCancel);
    }

    $q.when(userRoles).then(function (data) {
      var results = data.results ? data.results : data;
      if (service.isNotStaff()) {
        var valid_roles = [];
        angular.forEach(results, function (role) {
          if (isNull(role.base_type) || (role.base_type.toString() !== AccountUserRoleService.BASE_TYPE_OWNER)) {
            valid_roles.push(role);
          }
        });
        userRoles = $filter('orderBy')(valid_roles, 'name');
      }
      else {
        userRoles = $filter('orderBy')(results, 'name');
      }
      defer.resolve(userRoles);
    });
    return defer.promise;
  };

  service.getData = function () {
    $rootScope.$broadcast('changeHeaders');
    var defer = $q.defer();
    service.reInitializeHelpSection();

    // First, get the user
    AuthService.getUser(true).then(
      async function (user) {
        var params = user.is_staff ? { summary: true, exclude: 'owners'} : {exclude: 'owners,managed_by_me'};

        StatsigService.updateUser({
          userID: String(user.id),
          statsigEnvironment: {
            tier: StatsigService.getEnvironmentTier()
          },
        });

        StatsigService.checkGate('zendesk__enabled').then(function (enabled) {
          if (enabled && !$rootScope.isInIframe) {
            ZendeskService.load();
          }
        });

        var parallelCalls = [
          CacheService.getOrFetch('accounts', function() {
            return AccountService.getAll(params);
          }),
          AccountUserService.getCurrent(true),
          CacheService.getOrFetch('sectors', function() {
            return SectorRestService.getAll({ summary: true });
          }),
          CacheService.getOrFetch('categories', function() {
            return CategoryRestService.getAll({ summary: true });
          }),
          CacheService.getOrFetch('subcategories', function() {
            return SubCategoryRestService.getAll({ summary: true });
          }),
          CacheService.getOrFetch('account-users-roles', function() {
            return AccountUserRoleService.getAll({ ordering: 'name', summary: true, system: user.is_staff || user.is_white_label_admin });
          }),
          StatsigRestService.getActiveGates(user.id).catch(function(error) {
            console.error('[AUTH_DATA] Statsig gates failed, continuing with empty gates:', error);
            return { active_gates: [] }; // Return empty gates instead of rejecting
          }),
          FilterService.init(null, true)
        ];

        // Add client instance and white label calls if the user has a client instance
        if (user.client_instance) {
          parallelCalls.push(
            CacheService.getOrFetch('clientInstance', function() {
              return ClientInstanceService.getClientInstanceById(user.client_instance.id, true);
            }),
            CacheService.getOrFetch('whiteLabel', function() {
              return WhiteLabelService.get(user.client_instance.white_label, true);
            })
          );
        }

        // Execute all API calls in parallel
        $q.all(parallelCalls).then(
          async function (data) {
            // Extract results from the API responses
            var results_accounts = data[0].results || data[0];
            var accountUserResp = data[1];
            var sectors = data[2],
                categories = data[3],
                subcategories = data[4],
                accountUserRoles = data[5];
            var statsigData = data[6];

            // Add Statsig gates to user object
            user.statsig_active_gates = statsigData?.active_gates || [];


            // Populate service.authData with the fetched data
            service.authData = {
              accountsManager: results_accounts,
              user: user,
              accountUser: accountUserResp.current || null,
              accountUsers: accountUserResp.list || [],
              sectors: sectors,
              categories: categories,
              subcategories: subcategories,
              account_user_roles: accountUserRoles
            };

            // Set the selected account if the user is not a staff member
            if (service.authData.accountUser && service.isNotStaff()) {
              var selectedAccount = results_accounts.find(account => account.id === service.authData.accountUser.account);
              service.authData.account = selectedAccount || null;
            }

            AnalyticsService.identifyUser(user, service.authData);
            const authProvider = localStorage.getItem('auth_provider');
            if (authProvider) {
              AnalyticsService.track('User Signed In', {
                authentication_provider: authProvider
              });
              localStorage.removeItem('auth_provider');
            }

            // Handle client instance and white label
            if (user.client_instance) {
              var clientResult = data[8];
              var whiteLabelResult = data[9];
              var modifiedResult = modifyResponse(clientResult, whiteLabelResult);
              service.authData.whiteLabel = modifiedResult;
              ConfigThemeService.updateThemeConfig(modifiedResult);
            } else {
              ConfigThemeService.updateThemeConfig(ConfigThemeService.default_config, false);
            }

            const accountId = service.authData.account ? service.authData.account.id : '';
            const { first_name, last_name, date_joined, email, id } = service.authData.user;

            if (window.DD_RUM && email) {
              window.DD_RUM.setUser({
                id: email,
                email: email,
                account_id: String(accountId)
              });
              window.DD_RUM.setGlobalContextProperty('account_id', String(accountId));
            }
            // Initialize filter service
            await FilterService.getSetProperty(results_accounts);
            FilterService.initManagers(service.authData);

            // Initialize ChurnZero and ProductFruits
            if(window.LEO_CHURNZERO_KEY){
              ChurnZero.push(['setAppKey', window.LEO_CHURNZERO_KEY]); // AppKey from ChurnZero
              ChurnZero.push(['setVanityDomain','leonardo247.us1app']); // Vanity domain from environment
              ChurnZero.push(['setContact', accountId, email]);
            }

            let productFruitsUserData = {
              username: id,
              firstname: first_name,
              lastname: last_name,
              email: email,
              signUpAt: date_joined,
              account_id: accountId
            }
            if (!$rootScope.isInIframe) {
              $productFruits.push(['init', '5XhRwSPBVog0ngQz', 'en', productFruitsUserData]);
            }
            // Resolve the promise
            defer.resolve(service.authData);
          },
          function (error) {
            // If any API call in $q.all fails, reject the promise
            defer.reject(error);
          }
        );
      },
      function (error) {
        // If AuthService.getUser fails, reject the promise
        defer.reject(error);
      }
    );

    return defer.promise;
  };

  function modifyResponse(clientResult, whitlabelResult) {
    return {
      'admin_permissions': clientResult.admin_permissions[0],
      'company_help_email': whitlabelResult.company_help_email,
      'default_account_permissions': clientResult.default_account_permissions[0],
      'default_from_email': whitlabelResult.default_email,
      'id': clientResult.id,
      'logo1': whitlabelResult.principal_logo,
      'logo2': whitlabelResult.public_logo,
      'logo3': whitlabelResult.favicon_logo,
      'name': clientResult.name,
      'theme_config': {
        auxColor: whitlabelResult.aux_color,
        errorColor: whitlabelResult.error_color,
        primaryColor: whitlabelResult.primary_color,
        secondaryColor: whitlabelResult.secondary_color,
        successColor: whitlabelResult.success_color,
        tertiaryColor: whitlabelResult.tertiary_color,
        warningColor: whitlabelResult.warning_color
      },
      'url_config': {
        api_url: whitlabelResult.api_url,
        media_url: whitlabelResult.media_url,
        web_url: whitlabelResult.web_url
      }
    }
  }

  service.getWhiteLabel = function() {
    return (service.authData.user && service.authData.user.white_label) ?
      (service.authData.user.white_label.id || service.authData.user.white_label) : undefined;
  };

  service.getClientInstance = function() {
    return (service.authData.user && service.authData.user.client_instance) ?
      (service.authData.user.client_instance.id || service.authData.user.client_instance) : undefined;
  };

  service.isAdmin = function() {
    return service.authData.user ? service.authData.user.is_staff : false;
  };

  service.isLEOAdmin = function() {
    return service.authData.user ? service.authData.user.id === 1 : false;
  };

  service.isWhiteLabelAdmin = function() {
    return service.authData.user ? service.authData.user.is_white_label_admin : false;
  };

  service.isNotStaff = function() {
    return !service.isAdmin() && !service.isWhiteLabelAdmin();
  };

  service.isWorkAsUser = function() {
    return !isNull(AuthService.getOldUserId());
  };

  $rootScope.$on('user:logout', function (e) {
    service.authData = {};
    service.reInitializeHelpSection();
    FilterService.clearData();
    ZendeskService.remove();
    if (window.DD_RUM) {
      window.DD_RUM.clearUser();
      window.DD_RUM.removeGlobalContextProperty('account_id');
    }
  });

  service.reInitializeHelpSection = function() {
    if ($rootScope.isInIframe) {
      return;
    }
    if(window.productFruits && window.productFruits.services){
      window.productFruits.services.destroy();
    }
    (function (w, d, u) {
      w.$productFruits = [];
      w.productFruits = {}; w.productFruits.scrV = '2';
      let a = d.getElementsByTagName('head')[0]; let r = d.createElement('script'); r.async = 1; r.src = u; a.appendChild(r);
    })(window, document, 'https://app.productfruits.com/static/script.js');
  }

  return service;
};

app.factory('AuthDataService', ['$q', '$rootScope', '$filter', 'SectorRestService', 'CategoryRestService',
  'SubCategoryRestService', 'AccountUserService', 'AccountService','AccountUserRoleService', 'WhiteLabelService',
  'AuthService', 'FilterService', 'ConfigThemeService', 'ClientInstanceService', 'AnalyticsService',
  'CacheService', 'StatsigService', 'StatsigRestService', 'ZendeskService', AuthDataService]);
